const isContextValueEmpty = (value: unknown) =>
  value == null || value === "" || value === "unknown";

function applyArtlistDefaults(
  context: Record<string, any>,
): Record<string, any> {
  if (isContextValueEmpty(context.Email)) return context;
  if (!isContextValueEmpty(context.Subscriptionplanname)) return context;
  return { ...context, Subscriptionplanname: "Free Trial" };
}

export function applyContextDefaults(
  context: Record<string, any>,
  workspace?: string | null,
): Record<string, any> {
  if (!workspace) return context;

  switch (workspace.toLowerCase()) {
    case "artlist":
      return applyArtlistDefaults(context);
    default:
      return context;
  }
}
